import React, { useEffect, useState } from 'react'
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    Button,
    Chip
} from '@mui/material';
import KenGrid from '../../../GlobalComponents/KenGrid';
import routes from '../../../Utils/routes';
import { Checkbox } from '@mui/material'; //
import { getParentTeacherConnections, postAbsentPresentConnections } from '../../../Utils/apiService';
import KenLoader from '../../../GlobalComponents/KenLoader';


const useStyles = makeStyles(() => ({
    mainContainer: {
        textAlign: 'start',
    },
    cardItem: {
        backgroundColor: '#F6F8FB',
        padding: '12px',
        borderRadius: '8px',
        flex: 1,
        minWidth: '150px',
        maxWidth: '180px',
        // boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        '& .label': {
            fontSize: '14px',
            color: '#6B7280',
        },
        '& .value': {
            fontSize: '16px',
            fontWeight: 500,
            color: '#111827',
        },
    },
}))
function formatWeekRange(dateStr: string): string {
    const date = new Date(dateStr);
    const day = date.getDay(); // 0 (Sun) to 6 (Sat)

    // Get the Sunday of the current week
    const sunday = new Date(date);
    sunday.setDate(date.getDate() - day);

    // Get the Saturday of the current week
    const saturday = new Date(sunday);
    saturday.setDate(sunday.getDate() + 6);

    const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' };

    const formattedStart = sunday.toLocaleDateString('en-US', options); // e.g., July 12
    const formattedEnd = saturday.getDate(); // just day number
    const year = date.getFullYear();

    return `${formattedStart} - ${formattedEnd}, ${year}`;
}

function convertUTCToISTTime(utcTimeStr: string): string {
    const utcDate = new Date(`1970-01-01T${utcTimeStr}`); // assume a dummy date
    const options: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Kolkata',
    };

    return utcDate.toLocaleTimeString('en-US', options);
}


const ParentTeacherConference = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const url = window.location.pathname;
    const segments = url.split('/');
    const studentId = segments[segments.length - 1];
    const [page, setPage] = useState<number>(0);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [pTConferenc, setPTConference] = useState<any>([]);
    const rowsPerPage = 5;

    const handleChangePage = (_: any, newPage: number) => {
        setPage(newPage);
    };

    useEffect(() => {
        setLoading(true);
        getParentTeacherConnections(studentId)
            .then((data) => {
                setLoading(false);
                const response = data?.records;
                console.log(data, "dfkndfdskj");
                let tempArray = response?.map((item: any, index: number) => {
                    return {
                        Date__c: item?.Date__c,
                        GPA__c: item?.GPA__c,
                        Time__c: item?.Time__c,
                        Grade__c: item?.Grade__c,
                        Status__c: item?.Status__c,
                        Parent_s_Name__c: item?.Parent_s_Name__c,
                        Name: item?.Student__r?.Name,
                        Registration_Number__c: item?.Student__r?.Registration_Number__c,
                        Conference__r_Status: item?.Conference__r?.Status__c,
                        id: item?.Id,
                        Student__c: item?.Student__c,
                        Post_Meeting_Notes__c: item?.Post_Meeting_Notes__c,
                        Pre_Meeting_Notes__c: item?.Pre_Meeting_Notes__c
                    }
                })
                setPTConference(tempArray)
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

            })
    }, [])

    const handleNavigation = (student: any) => {
        let PTCNotes = {
            Post_Meeting_Notes__c: student?.Post_Meeting_Notes__c,
            Pre_Meeting_Notes__c: student?.Pre_Meeting_Notes__c
        }
        localStorage.setItem("PTCNotes", JSON.stringify(PTCNotes))
        navigate(`${routes.ParentSpecific}/${student?.Student__c}`)
    }

    const handleStatusChange = (studentId: string, newStatus: string) => {
        setPTConference((prev: any[]) =>
            prev.map((student: any) =>
                student.id === studentId ? { ...student, Status__c: newStatus } : student
            )
        );

        const payload = {
            Status__c: newStatus,
        };

        setLoading(true);

        postAbsentPresentConnections(payload, studentId)
            .then((res) => {
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to update status:", err);
                setLoading(false);
            });
    };


    return (
        <>
            <div className={`container ${classes.mainContainer}`}>
                {
                    loading && <KenLoader />
                }
                <div className='d-flex gap-4'>
                    {
                        pTConferenc[0]?.Conference__r_Status === "Ongoing" ? <Typography>Meeting Schedule</Typography> : <Typography>Completed Meetings</Typography>
                    }
                </div>
                <Box sx={{ width: '100%', padding: 3 }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow >
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Role number</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Student Name</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Parent's name</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Date</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Time</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Grade</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>GPA</TableCell>
                                    <TableCell style={{ color: '#172E7D', fontSize: '14px' }}>Status</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pTConferenc.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((student: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{student?.Registration_Number__c}</Typography></TableCell>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{student?.Name}</Typography></TableCell>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{student?.Parent_s_Name__c}</Typography></TableCell>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{formatWeekRange(student?.Date__c)}</Typography></TableCell>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{convertUTCToISTTime(student?.Time__c)}</Typography></TableCell>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{student?.Grade__c}</Typography></TableCell>
                                        <TableCell sx={{ border: 'none' }}><Typography sx={{ fontSize: '14px' }}>{student?.GPA__c}</Typography></TableCell>
                                        <TableCell sx={{ fontSize: '14px', border: 'none' }}>
                                            <Box display="flex" alignItems="center">
                                                {student?.Conference__r_Status === "Ongoing" ? (
                                                    <>
                                                        <Checkbox
                                                            checked={student?.Status__c === "Present"}
                                                            size="small"
                                                            onChange={(e) => {
                                                                const updatedStatus = e.target.checked ? "Present" : "Absent";
                                                                handleStatusChange(student.id, updatedStatus); // call your update function
                                                            }}
                                                        />
                                                        <Typography>{student?.Status__c}</Typography>
                                                    </>
                                                ) : (
                                                    <Chip
                                                        label={student?.Status__c}
                                                        sx={{
                                                            height: 24,
                                                            px: '6px',
                                                            fontSize: 12,
                                                            color: student?.Status__c === "Absent" ? "#591414" : '#1F4E21',
                                                            backgroundColor: student?.Status__c === "Absent" ? "#F1BFBF" : "#C1DCC3",
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{ border: 'none' }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                sx={{ textTransform: 'none', borderRadius: 2 }}
                                                onClick={() => handleNavigation(student)}
                                            >
                                                View details
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        {/* <div className='mt-5'>
                            <TablePagination
                                component="div"
                                count={pTConferenc.length}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[5]}
                            />
                        </div> */}



                    </TableContainer>
                </Box>
            </div>
        </>
    )
}

export default ParentTeacherConference;